<template>
  <div class="ad-page">
    <HpsfirProPageHeader
      title="首页顶部"
      title-en="HOME TOP"
      description="配置首页顶部广告位，支持轮播或多广告均匀展示。"
    />
    <div class="ad-page__content">
      <Advertising position="hometop"/>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Advertising from '@/components/Advertising.vue';
</script>
<style lang="scss" scoped>
.ad-page {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__content {
    padding: 0 16px 16px;
  }

  @media (max-width: 767px) {
    gap: 12px;

    &__content {
      padding: 0 8px 12px;
    }
  }
}
</style>
